import React from "react"
import { useStaticQuery, graphql } from "gatsby"

export default function FaqCategory() {
  const data = useStaticQuery(
    graphql`
      query category {
        allMarkdownRemark {
            nodes {
              frontmatter {
                templateKey
                Man_heading
                bottom_title
                camoff_image
                featu_heading
                heading
                heading_one
                infographic_image
                intarg {
                  Strum {
                    Strum_image
                    strum_main_text
                    strum_sub_text
                  }
                  features {
                    featur_image
                    featur_main_text
                    featur_sub_text
                  }
                }
                main_title
                members_image
                sign_up_button
                strum_heading
                strum_image
                strumlogo_image
                sub_heading
                sub_title
                whiteboarding_image
                work_heading
                work_video
                footer_description
                footer_image
              }
            }
        }
      }
    `
  )

  return data;

}